import classNames from 'classnames'

export function BreakoutTable({
  className,
  children,
  testId,
  onScroll,
  ref,
}: {
  className?: string
  children?: React.ReactNode
  testId?: string
  onScroll?: (event: React.UIEvent<HTMLTableElement>) => void
  ref?: React.Ref<HTMLTableElement>
}) {
  return (
    <table
      className={classNames('breakout-table', className)}
      data-testid={testId}
      onScroll={onScroll}
      ref={ref}
    >
      {children}
    </table>
  )
}
